function paragraph(size, bold) {
    let classes = "";

    if (size == 1)
        classes += ' fs-4';
    if (size == 2)
        classes += ' fs-5';
    if (size == 3)
        classes += ' fs-6';

    if (bold)
        classes += ' fw-bold';

    return classes;
}

export default {
    paragraph
}
